import _get from 'lodash/get';

export const getPromoMessage = (state) => _get(state, 'promoMessage.message', '');
export const getPromoMessageLoaded = (state) =>
  _get(state, 'promoMessage.promoMessageLoaded', false);
export const getPromoMessageLink = (state) => _get(state, 'promoMessage.link', '');
export const getPromoMessageBusy = (state) => _get(state, 'promoMessage.busy', false);
